<div *ngrxLet="currentTime$ as currentTime" class="heading">
  {{ currentTime | amDateFormat: timeFormat }}
</div>
